(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-localization')) {
    customElements.define('np-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.ready = true;
        this.trigger = this.querySelector('[data-locale-open]');
        this.form = this.querySelector('.np-locale-form');
        this.key = 'np-localization-choice-v1';
        this.sessionKey = 'np-localization-dismissed-v1';
        this.querySelector('.np-locale-fallback').hidden = true;
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => this.open());
        this.querySelector('[data-locale-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('np-locale-open');
          this.trigger.setAttribute('aria-expanded', 'false');
          try { sessionStorage.setItem(this.sessionKey, '1'); } catch {}
          if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll: true});
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.form.addEventListener('submit', event => {
          const changed = [...this.form.querySelectorAll('select')].some(select => select.value !== [...select.options].find(option => option.defaultSelected)?.value);
          try { localStorage.setItem(this.key, JSON.stringify({expires: Date.now() + 30 * 86400000})); } catch {}
          if (!changed) { event.preventDefault(); this.dialog.close(); return; }
          let returnTo = this.form.querySelector('[name="return_to"]');
          if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; this.form.append(returnTo); }
          returnTo.value = location.pathname + location.search + location.hash;
        });
        if (this.dataset.autoPrompt !== 'true' || this.remembered()) return;
        this.promptEvents = new AbortController();
        document.addEventListener('visibilitychange', () => this.tryPrompt(), {signal: this.promptEvents.signal});
        document.addEventListener('focusout', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.tryPrompt(), 300);
        }, {signal: this.promptEvents.signal});
        this.timer = setTimeout(() => this.tryPrompt(), 1500);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.stopTimer);
        this.observer?.disconnect();
        this.promptEvents?.abort();
        document.documentElement.classList.remove('np-locale-open');
      }
      remembered() {
        try {
          if (sessionStorage.getItem(this.sessionKey)) return true;
          return JSON.parse(localStorage.getItem(this.key) || 'null')?.expires > Date.now();
        } catch { return false; }
      }
      blocked() {
        if (document.visibilityState === 'hidden' || document.querySelector('dialog[open]')) return true;
        if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return true;
        return [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [data-cookie-banner]')].some(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      }
      tryPrompt() {
        if (this.remembered()) return;
        if (!this.blocked()) { this.observer?.disconnect(); clearTimeout(this.stopTimer); this.open(); return; }
        if (this.observer) return;
        this.observer = new MutationObserver(() => { clearTimeout(this.timer); this.timer = setTimeout(() => this.tryPrompt(), 300); });
        this.observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'hidden', 'style', 'class']});
        this.stopTimer = setTimeout(() => { this.observer.disconnect(); this.promptEvents?.abort(); clearTimeout(this.timer); }, 90000);
      }
      open() {
        if (this.dialog.open || document.querySelector('dialog[open]')) return;
        clearTimeout(this.timer);
        clearTimeout(this.stopTimer);
        this.observer?.disconnect();
        this.promptEvents?.abort();
        this.previousFocus = document.activeElement;
        this.form.reset();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('np-locale-open');
        this.dialog.showModal();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
